import {
  type FlowCreateNotableObjectBlock,
  FlowCreateNotableObjectConfigSchema,
  FlowNotableObject,
} from 'flow-schema';

import { CreateNotableObjectFormFields } from './FormFields';
import { CreateNotableObjectDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const createNotableObjectConfig: BlockConfigProps<FlowCreateNotableObjectBlock['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'CreateNotableObject',
  defaultConfig: {
    notableObject: FlowNotableObject.Patient,
    payload: '',
  },
  configFields: {
    schema: FlowCreateNotableObjectConfigSchema,
    FormFields: CreateNotableObjectFormFields,
  },
  documentationMarkdown: CreateNotableObjectDocumentationMarkdown,
};
